module.exports = __webpack_public_path__ + "static/media/digiquest.4c661880.png";